import React from 'react'
import { useSelector } from 'react-redux'
import GoogleMapReact from 'google-map-react'
import { selectMapStyle, selectZoom, selectCenter } from './features/mapReducer'
import { selectPins } from './features/pinsReducer'

function  MapPin({ text, src, zIndex }) {
  return <img alt="Map Pin"  src={src} style={{ zIndex, height: 50, position: 'relative',cursor: 'pointer', transform: 'translate(-50%, -100%)', }} />
}

function Map() {
  const pins = useSelector(selectPins)
  const mapStyle = useSelector(selectMapStyle)
  const zoom = useSelector(selectZoom)
  const center = useSelector(selectCenter)
  const options = { 
    styles: mapStyle,  
    fullscreenControl: false, 
    zoomControl: true
  }

	const style = {
    position: 'absolute',
    left: 375,
    top: 0,
		height: '100vh',
    width: '100%',
    zIndex: '0',
	}

  const mapPins = pins.map(p => <MapPin src={p.image} key={p.id} lat={p.lat} lng={p.lng} zIndex={p.zIndex}/>)


	return (
		<div style={style}>
      <GoogleMapReact
      center={ center }
      zoom={ zoom }
      options={options}
      >
        { mapPins }
      </GoogleMapReact>
		</div>
	)
}

export default Map
